var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aboutNetsol_x5F_SVG",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    enableBackground: "new 0 0 17 17",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1875BA",
    strokeWidth: 0.11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M14.063,8.79C14.063,8.789,14.063,8.789,14.063,8.79L1.628,1.604H1.624v4.282c0,0.996,0.547,1.862,1.354,2.325c0,0,0,0,0,0.001 l12.434,7.183h0.004v-4.281C15.415,10.117,14.868,9.25,14.063,8.79z M2.96,11.098C2.233,10.686,1.72,9.939,1.624,9.07v6.322 l4.386-2.529L2.96,11.098L2.96,11.098z M11.029,4.141l3.052,1.762v0.001c0.726,0.414,1.239,1.158,1.335,2.029V1.608L11.029,4.141z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1875BA",
    strokeWidth: 0.11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 15.416,1.608 13.563,5.604 15.413,3.804 11.029,4.141 15.416,5.599 15.118,6.971 14.001,2.438  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1875BA",
    strokeWidth: 0.11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 15.415,15.396 6.421,4.374 2.068,7.381 15.389,11.348 6.845,10.47 2.634,2.211  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1875BA",
    strokeWidth: 0.11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 1.628,1.604 4.597,9.123 13.52,8.477 10.52,12.584 14.88,9.538 15.411,15.396 12.846,8.116  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1875BA",
    strokeWidth: 0.11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 1.624,9.07 2.519,14.869 3.774,11.576 5.233,13.324 1.585,14.292 3.095,11.202 3.91,14.105  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/vector3.32d5f5a2ee04782bb427aae78681c7de.svg";
export { ForwardRef as ReactComponent };